var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoHands = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.25C7.42 0.25.87 6.74.87 14.75S7.42 29.25 15.5 29.25s14.63-6.49 14.63-14.5S23.58.25 15.5.25zm0 1.88c7.03 0 12.73 5.66 12.73 12.62s-5.7 12.62-12.73 12.62-12.73-5.66-12.73-12.62 5.7-12.62 12.73-12.62zm-7.11 7.85l1.29-1.28 5.82 5.77 5.82-5.77 1.29 1.28-5.82 5.77 5.82 5.77-1.29 1.28-5.82-5.77-5.82 5.77-1.29-1.28 5.82-5.77-5.82-5.77z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoHands);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoHands.83fcec97a07fa213c07e24d622603dd8.svg";